import { createEntityHooks } from '../core/createEntityHooks'
import type { BaseDocument } from '../core/types'

/**
 * Label document interface
 */
export interface LabelDocument extends BaseDocument {
  name: string
  color: string
  description: string | null
  projectId: string | null
  labelGroupId: string | null
  sortOrder: string | null
}

/**
 * Label-specific hooks
 */
const hooks = createEntityHooks<LabelDocument>('labels')

export const useLabels = (filter?: Partial<LabelDocument>) => {
  const { data, isLoading, db } = hooks.useEntities(filter)
  return { labels: data, isLoading, db }
}

export const useLabel = (id: string | undefined) => {
  const { data, isLoading } = hooks.useEntity(id)
  return { label: data, isLoading }
}

export const useLabelMutations = () => {
  const { create, update, delete: deleteEntity } = hooks.useMutations()
  return {
    createLabel: create,
    updateLabel: update,
    deleteLabel: deleteEntity,
  }
}
